import { Component, OnInit, ViewChild, ViewEncapsulation, ChangeDetectionStrategy} from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AppService } from "@irb/app.service";
import { DropdownFilterComponent } from "@irb/irb-common/components/dropdown-filter/dropdown-filter.component";
import { IrbClientsEvents, IrbAppEvents } from "@irb/irb-common/events";
import { IDropdownItem } from "@irb/irb-common/models/dropdown.model";
import { AssignedAccountsService } from "../assigned-accounts/assigned-accounts-service";
import { IAccountNameList, ICreateExternalAccount, IExternalAccountExists } from "../irb-clients.model";

@Component({ standalone: false,
  selector: "irb-create-external-accounts-dialog",
  templateUrl: "./create-external-accounts-dialog.component.html",
  styleUrls: ["./create-external-accounts-dialog.component.scss",  '../../irb-common/styles/dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager
})
export class CreateExternalAccountsDialogComponent implements OnInit {
  @ViewChild("irbTaxabilityDropdown")
  irbTaxabilityDropdown: DropdownFilterComponent;
  @ViewChild("irbAccountDropdown")
  irbAccountDropdown: DropdownFilterComponent;
  @ViewChild("irbAdvisorDropdown")
  irbAdvisorDropdown: DropdownFilterComponent;

  acctExists = false;
  isAccActive = false;
  viewLoaded = false;

  accountLocationType = {};
  master = {};
  portfolioId = {};

  masterDropdownValues: IDropdownItem[] = [];
  accountNameValuesList: IDropdownItem[] = [];

  externalAccount: ICreateExternalAccount = {
    accountNumber: "",
    accountName: "",
    accountLocationType: "",
    portfolioId: "",
    masterAcctNumber: "",
    masterAcctType:""
  };
  isRestoreExisted =  false;
  restoreOrNewRadio = true;
  restoreAccount = '';
  private restoreExternalAccountId: any = null;
  constructor(
    public dialogRef: MatDialogRef<CreateExternalAccountsDialogComponent>,
    private assignedAccountsService: AssignedAccountsService,
    private as: AppService
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.viewLoaded = true;
    }, 100);
    this.getAccountNameDropDownValues();
    this.getMasterItems();
  }

  close() {
    this.dialogRef.close();
  }

  onTaxabilityChange(event: IDropdownItem) {
    this.accountLocationType = event;
    this.externalAccount.accountLocationType = event.value;
  }

  onMasterChange(event: IDropdownItem) {
    this.master = event;
    this.externalAccount.masterAcctNumber = event.value.split("-")[0];
    this.externalAccount.masterAcctType = event.value.split("-")[1];
  }

  onAccountChange(event: IDropdownItem) {
    this.portfolioId = event;
    this.externalAccount.portfolioId = event.value;
  }

  getTaxabilityItems(): void {
    let items = [
      { name: "TAXABLE", value: "TAXABLE" },
      { name: "DEFERRED", value: "DEFERRED" },
      { name: "ROTH", value: "ROTH" }
    ];
    const f: Array<IDropdownItem> = [].concat(items);
    this.irbTaxabilityDropdown.set(f);
  }

  getAccountNameDropDownValues() {
    this.assignedAccountsService
      .getPfDropdown()
      .subscribe(
        (res: IAccountNameList) => {
          this.accountNameValuesList = res.items;
        }
      );
  }

  getMasterItems() {
    this.assignedAccountsService
      .getMasterAccounts()
      .subscribe(
        (res: string[]) => {
          res.sort(this.compare);
          const masterDropdownValues = res.map((value: string) => ({
            name: value.split("-")[0],
            value: value,
          }));
          this.masterDropdownValues = masterDropdownValues;
        }
      );
  }

  setAccountNameDropDownValues(value: string) {
    const filteredAccount = DropdownFilterComponent.getFilteredList(value, this.accountNameValuesList);
    this.irbAccountDropdown.set(filteredAccount);
  }

  setMasterItems(value: string) {
    const filteredMaster = DropdownFilterComponent.getFilteredList(value, this.masterDropdownValues);
    this.irbAdvisorDropdown.set(filteredMaster);
  }

  private compare(a: string, b: string) {
    const A = a.toUpperCase();
    const B = b.toUpperCase();

    let comparison = 0;
    if (A > B) {
      comparison = 1;
    } else if (A < B) {
      comparison = -1;
    }
    return comparison;
  }

  isValidSelections(): boolean {
    return (
      !!this.externalAccount.accountName &&
      !!this.externalAccount.accountNumber &&
      !!this.externalAccount.accountLocationType && 
      !!this.externalAccount.portfolioId && 
      !!this.externalAccount.masterAcctNumber
    );
  }

  createExternalAccount(): void {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);

    this.assignedAccountsService.checkExternalAcctExists(this.externalAccount.accountNumber).subscribe((data: IExternalAccountExists) => {
      this.acctExists = data.acctExists;
      this.isAccActive = data.isActive;
      this.restoreAccount = '';
      this.isRestoreExisted = this.acctExists && !this.isAccActive && data.acctId != null;
      if(!data.acctExists) {
        this.createExternalAcctExec(this.externalAccount)
      } else {
        this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
      }
      if (this.isRestoreExisted) {
        this.restoreExternalAccountId = data.acctId;
        this.restoreAccount = this.externalAccount.accountNumber;
        this.externalAccount.accountNumber = '';
        this.restoreOrNewRadio = true;
      }

    });
  }

  createExternalAcctExec(accountObject: any) {
    this.as.fireEvent(IrbAppEvents.SHOW_WAIT);
    this.assignedAccountsService.createExternalAcct(accountObject).subscribe((response: any) => {
      if(response.responseStatus === 'SUCCESS') {
        if (response.responseData && Array.isArray(response.responseData)) {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          this.as.fireEvent(IrbClientsEvents.SHOW_CREATE_EXTERNAL_ACCOUNTS_COMPLETE, {accountDetails: response.responseData[0]});
        } else {
          this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
          this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
            severity: "error",
            summary: "Create External Account",
            detail: "An error occurred processing your request."
          });
        }
        this.close();
      }
    }, () => {
      this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
    });
  }
  isValidSelectionsAfterRestore(): boolean {
    return (
        (this.isRestoreExisted && this.restoreOrNewRadio) ||
        (this.restoreOrNewRadio === false && !!this.externalAccount.accountNumber && this.isRestoreExisted)
    );
  }

  createOrRestoreExternalAccount() {
    if (this.restoreOrNewRadio) {
      let accountObject: any = {
        accountNumber: this.restoreAccount,
        accountName: this.externalAccount.accountName,
        accountLocationType: this.externalAccount.accountLocationType,
        portfolioId: this.externalAccount.portfolioId,
        masterAcctNumber: this.externalAccount.masterAcctNumber,
        masterAcctType: this.externalAccount.masterAcctType,
        accountId: this.restoreExternalAccountId
      };

      this.createExternalAcctExec(accountObject);
    } else {
      this.createExternalAccount();
    }
  }
}
